import { httpClient } from '@/core/api/http-client'
import type { Staff, StaffCreateInput, StaffUpdateInput } from '@/domain/entities/staff.entity'
import type { AccountRepository } from '@/domain/repositories/account.repository'
import { unwrap, unwrapList } from '@/infrastructure/shared/unwrap'
import type { StaffDto } from './account.dto'
import { accountMapper } from './account.mapper'

export class AccountHttpRepository implements AccountRepository {
  async list(outletId: string | null): Promise<Staff[]> {
    const raw = await httpClient.get<unknown>('/users', {
      params: { outlet_id: outletId ?? undefined },
    })
    return unwrapList<StaffDto>(raw).map(accountMapper.toStaff)
  }

  async create(input: StaffCreateInput): Promise<Staff> {
    const raw = await httpClient.post<unknown>('/users', {
      username: input.username,
      password: input.password,
      name: input.name,
      role_id: input.roleId,
      all_outlets: input.allOutlets,
      outlet_ids: input.outletIds,
    })
    return accountMapper.toStaff(unwrap<StaffDto>(raw))
  }

  async update(id: string, input: StaffUpdateInput): Promise<Staff> {
    const raw = await httpClient.put<unknown>(`/users/${id}`, {
      role_id: input.roleId,
      all_outlets: input.allOutlets,
      outlet_ids: input.outletIds,
    })
    return accountMapper.toStaff(unwrap<StaffDto>(raw))
  }

  async remove(id: string): Promise<void> {
    await httpClient.delete(`/users/${id}`)
  }

  async setActive(id: string, active: boolean): Promise<void> {
    await httpClient.put(`/users/${id}/active`, { active })
  }

  async changePassword(id: string, newPassword: string): Promise<void> {
    await httpClient.put(`/users/${id}/password`, { new_password: newPassword })
  }
}
